import { Component, DestroyRef, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CmsItem } from '@coin/shared/cms/util';
import { V2ButtonComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { SelectMediaComponent } from '../../../dialogs/shared/select-media/select-media.component';
import { EnlargeImageComponent } from '../../../dialogs/shared/enlarge-image/enlarge-image.component';

@Component({
  selector: 'coin-equity-cms-full-widthpart-with-image',
  templateUrl: './equity-cms-full-widthpart-with-image.component.html',
  styleUrls: ['./equity-cms-full-widthpart-with-image.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatFormFieldModule, TranslateModule, FormsModule, V2ButtonComponent, V2TextInputComponent]
})
export class EquityCmsFullWidthpartWithImageComponent {
  private readonly dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);

  @Input() item: CmsItem<'full-width-part-with-image'>;
  @Input() contentEdit = false;
  @Input() enableEnlarge = true;

  /**
   * Open popup to select a different image or upload a new one
   * @param item current image item
   */
  public editPicture(item: CmsItem<'full-width-part-with-image'>['content']): void {
    SelectMediaComponent.openDialog(this.dialog, { url: item?.imageUrl, mediaType: 'image' })
      .pipe(
        filter(newImage => !!newImage),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(newImage => {
        item.imageUrl = newImage.mediaUrl;
      });
  }

  /**
   * Open popup with current image but bigger in size
   */
  public enlargeImage(): void {
    this.dialog.open(EnlargeImageComponent, { data: { imageUrl: this.item.content.imageUrl } });
  }
}
